import React  from 'react';
import axios from 'axios'
import Swal from 'sweetalert2';
import { GoogleLogin } from 'react-google-login';
import { useState } from 'react';


function HeroHome() {

  let clientId = "853630294487-a53aadbo8qqr96ajhd54arpd10ftt2g9.apps.googleusercontent.com";
  const [loginState, setLoginState] = useState(0);

  let accessText = loginState? "Access Requested": "Be a better founder!";

  const successCallback = async (response) => {
    try{
        let output = await axios.post('/.netlify/functions/accountinfo',
          JSON.stringify({
            response
          }),
          {
            headers: { 
              'Access-Control-Allow-Origin': "*",
              'Access-Control-Allow-Credentials': true,
              'Content-Type': "application/json",
            },
          },
      )
      if(output.data === "new"){
        Swal.fire({
          background:' #18171D',
          iconColor:'rgba(52, 211, 153)',
          icon: "success",
          title: "Great, you're in! 🎉",
          text: "Thank you for joining HackPitch early access waitlist.",
          confirmButtonColor: "rgba(52, 211, 153)",
          timer:2000,
        });
      }
  
      setLoginState(1);
      
  
  
    } catch (err) {
      Swal.fire({
        background:' #18171D',
        icon: "error",
        title: "Oops!",
        text: "Something went wrong!",
        confirmButtonColor: "rgba(52, 211, 153)",
        timer:2000,
      });
    }
  }
  
  const failureCallback = async (response) => {
    console.log(response);
    Swal.fire({
      background:' #18171D',
      icon: "error",
      title: "Request Failed!",
      text: "Something went wrong! Please try again later.",
      confirmButtonColor: "rgba(52, 211, 153)",
      timer:2000,
    });
  }

  return (
    <section id="teams" className="relative">
      <div className="absolute bottom-0 -mb-32 transform -translate-x-1/2 pointer-events-none left-1/2" aria-hidden="true">
        <svg width="1760" height="518" viewBox="0 0 1760 518" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-02">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g transform="translate(0 -3)" fill="url(#illustration-02)" fillRule="evenodd">
            <circle cx="1630" cy="128" r="128" />
            <circle cx="178" cy="381" r="40" />
          </g>
        </svg>
      </div>

      {/* <div className="flex flex-col items-center justify-center h-screen px-8 text-center md:px-12">
            <h2 className="text-3xl font-semibold text-white md:text-5xl lg:text-9xl">Get <span className="text-green-400">Experts,</span></h2>
            <h2 className="text-3xl font-semibold text-white md:text-5xl lg:text-9xl">Startup<span className="text-green-400">!</span></h2>
            <h2 className="text-3xl font-semibold text-white md:text-5xl lg:text-9xl">Advice<span className="text-green-400">.</span></h2>
            <a className="p-5 mt-12 font-semibold text-black bg-green-400 w-25" href="#newsletter">Request Access</a>
            <a className="inline-flex items-center justify-center w-full px-8 py-3 mt-10 font-medium leading-snug text-black transition duration-150 ease-in-out bg-green-400 border border-transparent rounded shadow-lg hover:bg-green-700 sm:w-auto sm:mb-0" href="#newsletter">Request Access</a>
           
      </div> */}
      <div className="w-full h-screen bg-center bg-no-repeat bg-cover">
          <div className="relative flex items-center justify-center w-full h-screen bg-opacity-50">
              <div className="mx-4 text-center text-white">
              <h2 className="text-4xl font-semibold text-white md:text-9xl lg:text-8xl">Startup <span className="text-green-400">Learning,</span></h2>
                  <h2 className="text-4xl font-semibold text-white md:text-9xl lg:text-8xl">Peer<span className="text-green-400"></span> Feedback,</h2>
                  <h2 className="text-4xl font-semibold text-white md:text-9xl lg:text-8xl">Expert<span className="text-yellow-300"> Advice!</span></h2>
              </div>
              <div className="absolute bottom-14">
              <GoogleLogin
                  clientId={clientId}
                  render={renderProps => (
                    <button onClick={renderProps.onClick} disabled={renderProps.disabled || loginState} className="px-10 py-6 text-xl font-bold text-black transition duration-300 ease-in-out bg-yellow-300 border-2 border-black rounded-md hover:border-white hover:bg-green-400 hover:text-black">
                      {accessText}
                    </button>          
                  )}
                  buttonText="Login"
                  onSuccess={successCallback}
                  onFailure={failureCallback}
                  cookiePolicy={'single_host_origin'}
                  isSignedIn={true}
              />

              </div>
          </div>
      </div>
    </section>
  );
}

export default HeroHome;